var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4026 8.62478C15.9226 7.79228 13.2826 3.61478 8.79755 3.74978C4.65005 3.85478 2.25005 7.49978 1.59755 8.62478C1.46358 8.85683 1.46358 9.14273 1.59755 9.37478C2.07005 10.1923 4.59755 14.2498 9.01505 14.2498H9.20255C13.3501 14.1448 15.7576 10.4998 16.4026 9.37478C16.5365 9.14273 16.5365 8.85683 16.4026 8.62478ZM9.00005 11.6248C7.5503 11.6248 6.37505 10.4495 6.37505 8.99978C6.37505 7.55003 7.5503 6.37478 9.00005 6.37478C10.4498 6.37478 11.6251 7.55003 11.6251 8.99978C11.6251 10.4495 10.4498 11.6248 9.00005 11.6248ZM9.00005 10.1248C9.62137 10.1248 10.1251 9.6211 10.1251 8.99978C10.1251 8.37846 9.62137 7.87478 9.00005 7.87478C8.37873 7.87478 7.87505 8.37846 7.87505 8.99978C7.87505 9.6211 8.37873 10.1248 9.00005 10.1248Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEyeIcon);
export default __webpack_public_path__ + "static/media/whiteEyeIcon.e5d2680e24ba61e2864b37af8b5a2668.svg";
export { ForwardRef as ReactComponent };